/***************************************************************************/
"use client";
/***************************************************************************/

import { VariantProps, cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../../utils/css";
import { AlertContext } from "./alert";

const alertTitleVariants = cva("font-semibold tracking-tight mb-0 pr-8", {
  variants: {
    variant: {
      default: "",
      success: "text-success",
      info: "text-info",
      warning: "text-warning",
      error: "text-error",
    },
    size: {
      default: "text-base leading-tight",
      sm: "text-sm leading-tight",
      lg: "text-lg leading-tight",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement> &
    VariantProps<typeof alertTitleVariants>
>(({ className, variant, size, ...props }, ref) => {
  const contextValue = React.useContext(AlertContext);
  const derivedVariant = variant ?? contextValue.variant;
  const derivedSize = size ?? contextValue.size;

  return (
    <h5
      ref={ref}
      className={cn(
        alertTitleVariants({ variant: derivedVariant, size: derivedSize }),
        className,
      )}
      {...props}
    />
  );
});
AlertTitle.displayName = "AlertTitle";

export { AlertTitle, alertTitleVariants };
